export const AIMS_BAND_COUNT_VALUES = ["1", "3"]

export const AIMS_BAND_COUNT_OPTIONS = [
  { value: "", label: "-" },
  ...AIMS_BAND_COUNT_VALUES.map(value => ({ value, label: value })),
]
